<template>
  <div class="audio-container">
    <audio
      ref="audioRef"
      @play="onPlay"
      @pause="onPause"
      @ended="onEnded"
      :src="audioSrcPage"
      :autoplay="autoPlay"
      volume="50"
    ></audio>
    <div class="audio-content" :style="{ backgroundColor }">
      <img
        @click="toggleAudio"
        class="audio-btn-img"
        :src="
          isPlaying
            ? require('@/assets/img/audio_pause.png')
            : require('@/assets/img/audio_play.png')
        "
        alt=""
      />
      <!-- 时间显示 -->
      <span class="progress-time">{{ formatTime(currentTime) }}</span>
      <!-- 进度条 -->
      <input
        type="range"
        v-model="currentTime"
        :min="0"
        :max="duration"
        step="0.1"
        @input="seekAudio"
        class="progress-bar"
        :style="{ background: progressBarBackground }"
      />
      <span class="progress-time">{{ formatTime(duration) }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getQuestionVideoAudioUrl } from "@/http/index";

export default {
  props: {
    backgroundColor: {
      type: String,
      default: "#F7F8FA",
    },
    autoPlay: {
      type: Boolean,
      default: false,
    },
    audioSrc: "",
    vid: "",
  },
  data() {
    return {
      audioSrcPage: "",
      isPlaying: false,
      currentTime: 0, // 当前播放时间
      duration: 0, // 音频总时长
    };
  },
  computed: {
    ...mapState(["videoPlaying"]),
    // 动态计算进度条的背景色
    progressBarBackground() {
      const progress = (this.currentTime / this.duration) * 100;
      return `linear-gradient(to right, #ff6600 ${progress}%, #ddd ${progress}%)`;
    },
  },
  watch: {
    audioSrc: {
      handler(newVar, oldVar) {
        this.audioSrcPage = newVar;
      },
    },
    vid: {
      async handler(newVar, oldVar) {
        if (newVar) {
          const res = await getQuestionVideoAudioUrl({
            token: localStorage.getItem("token"),
            secret: localStorage.getItem("secret"),
            hospital_id: localStorage.getItem("hospital_id"),
            get_type: 1,
            type: 2,
            vid: this.vid,
          });
          this.audioSrcPage = res.data.playInfo.playurl;
          if (!this.autoPlay) {
            this.onPause();
          }
        }
      },
      immediate: true,
    },
    videoPlaying: {
      handler(newVar, oldVar) {
        if (newVar) {
          const audio = this.$refs.audioRef;
          if (audio) {
            audio.pause();
          }
        }
      },
    },
  },
  mounted() {
    // 确保 DOM 渲染完成后再添加事件监听
    this.$nextTick(() => {
      const audio = this.$refs.audioRef;
      // 获取音频的总时长
      audio.addEventListener("loadedmetadata", () => {
        this.duration = audio.duration;
      });
      // 监听音频进度变化
      audio.addEventListener("timeupdate", this.updateProgress);
    });
  },
  beforeDestroy() {
    // 移除监听器，防止内存泄漏
    const audio = this.$refs.audioRef;
    audio.removeEventListener("timeupdate", this.updateProgress);
  },
  methods: {
    // 格式化时间显示
    formatTime(time) {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    },
    seekAudio() {
      this.$refs.audioRef.currentTime = this.currentTime; // 跳转到指定时间
    },
    // 更新当前时间
    updateProgress() {
      this.currentTime = this.$refs.audioRef.currentTime;
    },
    async toggleAudio() {
      this.$nextTick(() => {
        const audio = this.$refs.audioRef;
        if (this.isPlaying) {
          audio.pause(); // 暂停音频
        } else {
          audio.play(); // 播放音频
        }
      });
    },
    onPlay() {
      this.isPlaying = true;
    },
    onPause() {
      this.isPlaying = false;
    },
    onEnded() {
      this.isPlaying = false;
    },
  },
};
</script>

<style scoped lang="scss">
.audio-container {
  margin-top: 12px;
  .audio-content {
    display: flex;
    align-items: center;
    width: 100%;
    height: 34px;
    border-radius: 8px;
    padding: 0 12px;
    .audio-btn-img {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
    .progress-time {
      font-size: 10px;
      color: #7b7e83;
    }
    .progress-bar {
      margin: 0 12px;
      width: 100%;
      height: 2px;
      background: #ddd;
      -webkit-appearance: none;
      border-radius: 5px;
    }

    .progress-bar::-webkit-slider-thumb {
      width: 7px;
      height: 7px;
      background: #ff6600;
      border-radius: 50%;
      -webkit-appearance: none;
    }

    .progress-bar::-moz-range-thumb {
      width: 7px;
      height: 7px;
      background: #ff6600;
      border-radius: 50%;
    }
  }
}
</style>